import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvQnAStore = new MMKV({
  id: MMKVStoreKeyMap.qnaFeedStore,
});
export const zustandQnaFeedStore: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvQnAStore.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvQnAStore.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvQnAStore.delete(name);
  },
};

